<div class="container">
  <button [disabled]="disabled" class="main-btn dropdown-btn filter-btn active-btn btn" [ngClass]="btnColor"  (click)="menuClicked($event)" 
  [matMenuTriggerFor]="menu">
    <div class="flex-grow-1 margin-r-s ">{{currentStatus}}</div>
    <div *ngIf="!disabled"><img src="assets/images/down-white.svg" /></div>
  </button>
  <mat-menu #menu="matMenu" >
    <button mat-menu-item (click)="checkout()">Check out</button>
    <button mat-menu-item (click)="markInactive()">Inactive</button>
    <button mat-menu-item (click)="suspectMissing()">Suspected Missing</button>
    <button mat-menu-item (click)="suspectStolen()">Suspected Stolen</button>
    <button mat-menu-item (click)="confirmMissing()">Confirmed Missing</button>
    <button mat-menu-item (click)="confirmStolen()">Confirmed Stolen</button>
    <button mat-menu-item (click)="lockout()">Locked Out</button>
    <button mat-menu-item (click)="recover()">Recovered</button>
  </mat-menu>
</div>
